<template>
  <div class="register">
    <div class="mask" @click="close"></div>
    <!-- 注册框 -->

    <div class="showLogin">
      <div class="form-container">
        <div class="reg_form">
          <div class="top_right">
            <i class="el-icon-close" @click="close"></i>
          </div>

          <!-- 表单 -->
          <div class="show_buttom">
            <div class="from">
              <h2>{{ $t('登录') }}</h2>
              <br />
              <el-form
                :rules="loginRules"
                :model="formLabelAlign"
                class="demo-ruleForm"
                ref="loginForm"
              >
                <el-form-item prop="name" :label="$t('账号')">
                  <el-input
                    @keydown.native.enter="subLogin('loginForm')"
                    class="formInput"
                    v-model="formLabelAlign.name"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="password" :label="$t('密码')">
                  <el-input
                    @keydown.native.enter="subLogin('loginForm')"
                    class="formInput"
                    show-password
                    v-model="formLabelAlign.password"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="captcha" :label="$t('验证码')">
                  <div class="yzmBox">
                    <el-input
                      @keydown.native.enter="subLogin('loginForm')"
                      class="formInput"
                      v-model="formLabelAlign.captcha"
                    >
                    </el-input>
                    <div
                      v-loading="isLoading"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(25, 30, 45, 1)"
                    >
                      <el-image @click="getCode" :src="codeImgObj.img">
                        <div slot="error" class="code_err" @click="getCode()">
                          {{ $t('加载失败') }}
                        </div>
                      </el-image>
                    </div>
                    <!-- <img  @click="getCode" :src="codeImgObj.img" alt=""> -->
                  </div>
                </el-form-item>

                <div class="reg-btn-container">
                  <el-form-item>
                    <div @click="subLogin('loginForm')" class="registBtn">
                      {{ $t('登录') }}
                    </div>
                  </el-form-item>

                  <div class="login-container">
                    <span>
                      Not a member? &nbsp;
                      <span @click="openRegister()">Create an account</span>
                      <img
                        src="@/static/images/double-chevron-right.svg"
                        alt=""
                      />
                    </span>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  axiosGetGameType,
  captcha,
  axiosLogin,
  axiosRegist,
  me,
  lang,
} from '@/api/apiIndex.js'
export default {
  data() {
    return {
      language: '',
      formLabelAlign: {
        name: '',
        password: '',
        captcha: '',
      },
      loginRules: {
        name: [
          { required: true, message: this.$t('请输入账号'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('请输入密码'), trigger: 'blur' },
        ],
        captcha: [
          { required: true, message: this.$t('请输入验证码'), trigger: 'blur' },
        ],
      },
      //验证码操作所需
      codeImgObj: {},
      codeIsClick: false,
      isLoading: false,
      loginLoading: false,
    }
  },
  created() {
    this.getCode()
    const val = JSON.parse(localStorage.getItem('language'))
    this.language = val.value

    const info = JSON.parse(sessionStorage.getItem('userInfo'))
    if (info !== null) {
      this.$router.push('/')
    }
  },
  methods: {
    close() {
      this.$emit('closeLogin', false)
    },
    openRegister() {
      this.$emit('closeLogin', false)
      this.$emit('registerPop', true)
    },
    maxPageLoading(text) {
      this.loading = this.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },
    // 获取验证码
    getCode() {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        if (this.codeIsClick) return
        this.codeImgObj = ''
        this.codeIsClick = true
        captcha()
          .then((res) => {
            resolve()
            this.codeIsClick = false
            if (res.code == 200) {
              this.codeImgObj = res.data
              this.isLoading = false
            }
          })
          .catch((err) => {
            reject()
            this.isLoading = false
            this.codeIsClick = false
          })
      })
    },
    // 注册弹窗注册 介绍人可不填
    subLogin(ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          if ('key' in this.codeImgObj) {
            let data = { ...data, ...this.formLabelAlign }
            data.key = this.codeImgObj.key
            data.site =
              location.hostname == 'localhost'
                ? '63s.online'
                : location.hostname
            this.maxPageLoading(this.$t('正在登录中'))
            if (this.loginLoading) return
            this.loginLoading = true
            axiosLogin(data)
              .then((res) => {
                if (res.code == 200) {
                  sessionStorage.setItem('token', JSON.stringify(res.data))
                  // 获取登录用户信息
                  this.getUserInfo(1)
                  this.close()
                } else {
                  this.loginLoading = false
                  this.loading.close()
                  this.getCode()
                  this.$message.error(res.message)
                }
              })
              .catch((err) => {
                this.loginLoading = false
                this.loading.close()
                this.getCode()
                this.$message.error(err.response.data.message)
              })
          } else {
            this.$message.error(this.$t('请重新获取验证码'))
          }
        }
      })
    },

    // 获取用户信息
    getUserInfo() {
      me()
        .then((res) => {
          this.loginLoading = false
          if (this.loading != '') {
            this.loading.close()
          }
          if (res.code == 200) {
            sessionStorage.setItem('userInfo', JSON.stringify(res.data))
            this.userInfoData = res.data
            this.$router.push('/')
            location.reload()
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((err) => {
          this.loginLoading = false
          // 返回code为401 token过期 公共js
          if (this.comJs.tokenIsExpire(err.response.data.error)) {
            this.noTOkenData = true
            return
          }
          this.$message.error(this.$t('网络异常,请稍后再试'))
        })
    },
  },
}
</script>

<style lang="less" scoped>
.register {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 9;
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
}
.mask {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100vh;
  z-index: 11;
}
.showLogin {
  z-index: 12;
  border-radius: 10px;
  background: #68dbfc;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .logo-container {
    position: relative;
    top: 0;
    display: flex;
    justify-content: center;
    padding: 12px 25px;

    img {
      height: 42px;
    }
  }

  .reg_form {
    width: 100%;
    border-radius: 30px;
  }

  .top_right {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 10px 20px;
    i {
      cursor: pointer;
      font-size: 24px;
      font-weight: 600;
      color: #6a6a6a;
    }
  }

  .show_top {
    display: flex;
    text-align: center;
    align-items: center;
    font-family: 'Saira', sans-serif;
    border-bottom: none;
    justify-content: center;

    .login {
      display: flex;
      gap: 15px;
      padding: 5px;
      border-radius: 10px;
      border: 2px solid #642630;
      background: linear-gradient(0deg, #110305 0%, #110305 100%), #13161d;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;

      div {
        padding: 10px 15px;
        min-width: 150px;
        color: #5777a6;
        text-transform: uppercase;
        cursor: pointer;

        &.selected {
          color: #fff;
          border-radius: 10px;
          background: #2d0e0e;
        }
      }
    }
  }
  .show_buttom {
    padding: 20px;
    overflow-y: auto;
  }
}

.reg-btn-container {
}

.login-container {
  span {
    color: #002b34;
    font-size: 14px;
    display: flex;
    align-items: center;

    span {
      color: #252525;
      font-weight: 600;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}

.registBtn {
  font-family: 'Saira', sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #fff;
  border-radius: 30px;
  background: #252525;
  text-align: center;
  cursor: pointer;
  font-weight: normal;
  padding: 0 50px;
  width: 100%;

  &:hover {
    background: #555;
    color: #fff;
  }
}
.yzmBox {
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/.el-input {
    width: 70%;
  }
}
/deep/ .el-input__inner {
  color: #fff;
  padding: 0 10px;
  border-radius: 5px;
  background: #002b34;
  box-shadow: 0px 0px 4px 1px rgba(255, 255, 255, 0.02) inset;

  &::placeholder {
    color: #979797;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dumanbet/login.vue